import React from "react";
import "./truck_super_save.css";

/**
 * 🟧 TruckSuperSaveDetails.jsx
 * แสดงรายละเอียดเบี้ยประกันภัย Truck Super Save 2+ / 3+
 * สำหรับรถบรรทุก 4–12 ตัน และ 12 ตันขึ้นไป (Single Rate)
 */

export default function TruckSuperSaveDetails({ onQuote }) {
  const rows = [
    { fund: "100,000", noExtra: "17,900", extra: "19,700" },
    { fund: "200,000", noExtra: "18,900", extra: "20,800" },
    { fund: "300,000", noExtra: "19,900", extra: "21,900" },
  ];

  return (
    <div className="pkg-detail truck-super-save">
      <h2>Truck Super Save ประเภท 5 (2+ / 3+)</h2>
      <p>
        รถบรรทุก และ รถลาก ใช้เพื่อการพาณิชย์
        (ไม่รับจ้าง/ให้เช่า) เบี้ยคงที่ Single Rate
      </p>

      <table className="pkg-table">
        <thead>
          <tr>
            <th>ทุนประกันภัย</th>
            <th>ไม่ติดอุปกรณ์พิเศษ (บาท)</th>
            <th>มีอุปกรณ์พิเศษ (บาท)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.fund}>
              <td>{r.fund}</td>
              <td>{r.noExtra}</td>
              <td>{r.extra}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <p>* รวม CCTV Discount และ App แจ้งเหตุแล้ว</p>
        <button className="pkg-quote-btn" onClick={onQuote}>
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
